import React from "react";

export default function ErrorHandle() {
  return <p>Something Went Wrong</p>;
}
